import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, catchError, of } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Injectable({
  providedIn: 'root',
})
export class PartstCountService {
  getToken = () => localStorage.getItem('Token');
  appJson = 'application/json';

  httpCustomOptions = () => {
    return {
      headers: new HttpHeaders({
        'Content-Type': this.appJson,
        Accept: this.appJson,
        Authorization: this.getToken(),
        'X-Api-Key': this.environment.partsinventoryKey,
      }),
    };
  };
  getApiHeaders = () => {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: this.getToken(),
      'X-Api-Key': this.environment.partsinventoryKey,
    });
  };
  

  // getPieHeaders = (token) => {
  //   return {
  //     headers: new HttpHeaders({
  //       Authorization: 'Bearer ' + token,
  //     }),
  //   };
  // };

  apiUrl = '';
  // sendToPieDataUrl = '';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) {
    this.apiUrl = environment.partsinventoryUrl;
    // this.sendToPieDataUrl = environment.sendToPieData;
  }

  getPartsCountGroup(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/editGroupsGrid`,
      //  `http://localhost:3000/status3`,

      data,
      this.httpCustomOptions()
    );
  }
  getEditGroupInsideGrid(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/partNoKanbanGrid`,
      //  `http://localhost:3000/getPartsCountEditGroupsPartNoKanbanData`,

      data,
      this.httpCustomOptions()
    );
  }
  deleteGroups(data): Observable<any> {
    const httpCustomOptions = {
      body: data,
      headers: this.getApiHeaders(),
    };
    return this.http.delete<any>(
      `${this.apiUrl}/deleteGroups`,
      // `http://localhost:3000/deleteGroups`,
      httpCustomOptions
    );
  }
  
  editGroups(data): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/editGroups`,
      //  `http://localhost:3000/editGroups`,

      data,
      this.httpCustomOptions()
    );
  }
  //addGroups
  addGroups(data): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/addGroups`,
      data,
      this.httpCustomOptions()
    );
  }
  //getGroupName
  getGroupName(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/group`,
      data,
      this.httpCustomOptions()).pipe(catchError(error => of({ error }))).pipe(catchError(error => of({ error }))
    );
  }
  //getAddress
  getAddress(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/address`,
      data,
      this.httpCustomOptions()).pipe(catchError(error => of({ error }))).pipe(catchError(error => of({ error }))
    );
  }
  //getPartsControl
  getPartsControl(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/partsControl`,
      data,
      this.httpCustomOptions()
    );
  }
  //getPartsCountData
  getPartsCountData(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/partsCountGrid`,
      data,
      this.httpCustomOptions()
    );
  }
  //for partscount download template
  getdownloadTemplate(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/template`,
      data,
      this.httpCustomOptions()
    );
  }
  //deletePartsCount
  deletePartsCount(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/deletePartsCount`,
      // `http://localhost:3000/api/v1/partsinventory/deletePartsCount`,
      data,
      this.httpCustomOptions()
    );
  }
  //partscount
  editsPartsCount(data): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/partscount`,
      data,
      this.httpCustomOptions()
    );
  }
  //uploadpartscount
  uploadPartsCount(data): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/uploadpartscount`,
      data,
      this.httpCustomOptions()
    );
  }
  //new Api's
  editGroup(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/editGroup`,
      data,
      this.httpCustomOptions()
    );
  }
  rightArrowButton(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/addParts`,
      data,
      this.httpCustomOptions()
    );
  }
  leftGridPartsNotInGroups(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/partsNotInGroups`,
      data,
      this.httpCustomOptions()
    );
  }
  // leftArrowButton
  deleteParts(data): Observable<any> {
    const httpCustomOptions = {
      body: data,
      headers: this.getApiHeaders(),
    };
    return this.http.delete<any>(
      `${this.apiUrl}/deleteParts`,
      // `http://localhost:3000/deleteParts`,
      httpCustomOptions
    );
  }
  getDefault(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/default`,
      data,
      this.httpCustomOptions()).pipe(catchError(error => of({ error }))).pipe(catchError(error => of({ error }))
    );
  }
  lineSideAddress(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/LS`,
      data,
      this.httpCustomOptions()).pipe(catchError(error => of({ error }))).pipe(catchError(error => of({ error }))
    );
  }
}
